
                    // ! automatically generated - Don't change this file manually
                    import React from 'react';
                    import load from '@loadable/component';

                    const LazyIcon = load(() => import('./index').then((m) => ({ default: m.IconMapPin })), { ssr: false });

                    const ICON_SIZE = { small: '1rem', medium: '1.25rem', large: '1.5rem' };

                    export const LazyIconMapPin = React.forwardRef((props, ref) => {
                        return (
                            <LazyIcon
                                ref={ref}
                                fallback={
                                    <span
                                        data-icon-suspense="map-pin"
                                        className={props.className}
                                        style={{
                                            height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                            width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                        }}
                                    />
                                }
                                {...props} />
                        );
                    });

                    LazyIconMapPin.displayName = 'LazyIconMapPin';
                